import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import { createForms } from "react-redux-form";
import logger from "redux-logger";
import { createEpicMiddleware } from "redux-observable";
import { discussionBoardAnalytics } from "../helpers/analytics";

export const configureStore = (reducer, rootEpic) => {
  const composeEnhancers = compose;

  const epicMiddleware = createEpicMiddleware(rootEpic);

  return createStore(
    reducer,
    composeEnhancers(applyMiddleware(epicMiddleware, discussionBoardAnalytics))
  );
};



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.ts